import React from "react";
import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import ResourceCrudPanel from "../../components/crm/ResourceCrudPanel";

export default function SectionCrudPage({ title, subtitle, resources, resourceLookup = null }) {
  const [activeTab, setActiveTab] = React.useState(0);

  React.useEffect(() => {
    setActiveTab(0);
  }, [resources]);

  const selectedResource = resources?.[activeTab];
  const computedResourceLookup = React.useMemo(() => {
    const sectionLookup = Object.fromEntries((resources || []).map((resource) => [resource.key, resource]));
    if (resourceLookup && typeof resourceLookup === "object") {
      return { ...resourceLookup, ...sectionLookup };
    }
    return sectionLookup;
  }, [resourceLookup, resources]);

  return (
    <Box sx={{ width: "100%", maxWidth: "1700px", margin: "auto" }}>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>{title}</Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {subtitle}
            </Typography>
          ) : null}

          <Tabs
            value={activeTab}
            onChange={(_, value) => setActiveTab(value)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {(resources || []).map((resource) => (
              <Tab key={resource.key} label={resource.label} />
            ))}
          </Tabs>
        </CardContent>
      </Card>

      {selectedResource ? (
        <ResourceCrudPanel resource={selectedResource} resourceLookup={computedResourceLookup} />
      ) : (
        <Card>
          <CardContent>
            <Typography color="error">No resources configured for this section.</Typography>
          </CardContent>
        </Card>
      )}
    </Box>
  );
}
